import { Api } from '@recargas-dominicanas/core/api';
import type { CustomerProduct } from '@recargas-dominicanas/core/types';

export class ProductsApi extends Api {

  public static async getAll() {
    return this.get<CustomerProduct[]>('/dist/products');
  }
}
